import { CardActionConfig, CardActionsRegistry } from "./types";

const CATALOG_ACTIONS: CardActionConfig[] = [
  {
    key: "enroll",
    labelKey: "actions.enroll",
    iconKey: "enroll",
    permission: "learning.enrollment.read",
    disableIf: ["is_standalone", "obsolete"],
    group: 1,
  },
  {
    key: "associate-initiatives",
    labelKey: "actions.associate-initiatives",
    iconKey: "associate-initiatives",
    permission: "learning_catalogue.learning_object.associate.initiatives",
    disableIf: ["obsolete"],
    group: 1,
  },
  {
    key: "see-editions",
    labelKey: "actions.see-editions",
    iconKey: "see-editions",
    permission: "learning_catalogue.learning_object.write",
    hideIf: ["notClassroomActivity"],
    group: 1,
  },

  {
    key: "enrolled-users",
    labelKey: "actions.enrolled-users",
    iconKey: "enrolled-users",
    permission: "learning.enrollment.read",
    disableIf: ["is_standalone"],
    group: 2,
  },
  {
    key: "pre-enrolled-users",
    labelKey: "actions.pre-enrolled-users",
    iconKey: "pre-enrolled-users",
    permission: "learning.enrollment.read",
    disableIf: ["is_standalone_unless_classroom"],
    group: 2,
  },
  {
    key: "waiting-users",
    labelKey: "actions.waiting-users",
    iconKey: "waiting-users",
    permission: "learning.enrollment.read",
    disableIf: ["is_standalone_unless_classroom"],
    group: 2,
  },
  {
    key: "enrolled-groups",
    labelKey: "actions.enrolled-groups",
    iconKey: "enrolled-groups",
    permission: "learning.enrollment.read",
    disableIf: ["is_standalone"],
    group: 2,
  },

  {
    key: "duplicate",
    labelKey: "actions.duplicate",
    iconKey: "duplicate",
    permission: "learning_catalogue.learning_object.write",
    group: 3,
  },
  {
    key: "edit",
    labelKey: "actions.edit",
    iconKey: "edit",
    permission: "learning_catalogue.learning_object.write",
    disableIf: ["notOwner"],
    group: 3,
  },

  // {
  //   key: "suspend",
  //   labelKey: "actions.suspend",
  //   iconKey: "suspend",
  //   permission: "learning_catalogue.learning_object.write",
  //   group: 3,
  // },
  // {
  //   key: "delete",
  //   labelKey: "actions.delete",
  //   iconKey: "delete",
  //   permission: "learning_catalogue.learning_object.write",
  //   group: 3,
  // },
];

const USER_ACTIONS: CardActionConfig[] = [
  {
    key: "enroll",
    labelKey: "actions.enroll",
    iconKey: "enroll",
    permission: "usermgmt.users.add",
    group: 1,
  },
  {
    key: "view-lo",
    labelKey: "actions.viewLearningObjects",
    iconKey: "view-lo",
    group: 1,
  },
  {
    key: "download-csv",
    labelKey: "actions.downloadCsv",
    iconKey: "download-csv",
    group: 1,
  },
  {
    key: "impersonate",
    labelKey: "actions.impersonate",
    iconKey: "impersonate",
    permission: "usermgmt.loginas",
    disableIf: ["noInitiatives"],
    group: 2,
  },
  {
    key: "edit",
    labelKey: "actions.edit",
    iconKey: "edit",
    permission: "usermgmt.users.add",
    group: 3,
  },
  {
    key: "block",
    labelKey: (u) =>
      String(u?.status).toLowerCase() === "suspended"
        ? "actions.unblock"
        : "actions.block",
    iconKey: (u) =>
      String(u?.status).toLowerCase() === "suspended" ? "unblock" : "block",
    permission: "usermgmt.users.add",
    group: 3,
  },
  {
    key: "delete",
    labelKey: "actions.delete",
    iconKey: "delete",
    permission: "usermgmt.users.add",
    group: 3,
  },
];

const STATIC_GROUP_ACTIONS: CardActionConfig[] = [
  {
    key: "enroll",
    labelKey: "actions.enroll",
    iconKey: "enroll",
    permission: "usermgmt.corporates.static_groups.read",
    group: 1,
  },
  {
    key: "view-lo",
    labelKey: "actions.viewLearningObjects",
    iconKey: "view-lo",
    permission: "usermgmt.corporates.static_groups.read",
    group: 1,
  },
  {
    key: "edit",
    labelKey: "actions.edit",
    iconKey: "edit",
    permission: "usermgmt.corporates.static_groups.write",
    group: 2,
  },
  {
    key: "delete",
    labelKey: "actions.delete",
    iconKey: "delete",
    permission: "usermgmt.corporates.static_groups.write",
    group: 2,
  },
];

const DYNAMIC_GROUP_ACTIONS: CardActionConfig[] = [
  {
    key: "enroll",
    labelKey: "actions.enroll",
    iconKey: "enroll",
    permission: "usermgmt.corporates.static_groups.read",
    group: 1,
  },
  {
    key: "view-lo",
    labelKey: "actions.viewLearningObjects",
    iconKey: "view-lo",
    permission: "usermgmt.corporates.static_groups.read",
    group: 1,
  },
  {
    key: "edit",
    labelKey: "actions.edit",
    iconKey: "edit",
    permission: "usermgmt.corporates.dynamic_groups.write",
    group: 2,
  },
  {
    key: "delete",
    labelKey: "actions.delete",
    iconKey: "delete",
    permission: "usermgmt.corporates.dynamic_groups.write",
    group: 2,
  },
];

export const cardActionsRegistry: CardActionsRegistry = {
  activity: CATALOG_ACTIONS,
  course: CATALOG_ACTIONS,
  path: CATALOG_ACTIONS,
  user: USER_ACTIONS,
  "group-static": STATIC_GROUP_ACTIONS,
  "group-dynamic": DYNAMIC_GROUP_ACTIONS,
};
